import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams, ValueGetterParams } from 'ag-grid-community';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ECRService } from 'src/app/service/ecr.service';
import { CrudService } from '../service/crud.service';
import { NgxSpinnerService } from 'ngx-spinner';
// import { ECRService } from '../service/ecr.service';

const MONTHS = ["January", "February", "March", "April", "May", "June", "July",
  "August", "September", "October", "November", "December"];

@Component({
  selector: 'app-ecr-for-hr',
  templateUrl: './ecr-for-hr.component.html',
  styleUrls: ['./ecr-for-hr.component.css']
})
export class EcrForHrComponent implements OnInit, OnDestroy {
  employeeEcrForm: FormGroup;
  activeWorkspace: 'tcpl' | 'thr' = 'tcpl';
  employeeDetailTab: 'calendar' | 'list' = 'calendar';
  private domLayout;
  private gridApi;
  private gridColumnApi;
  public columnDefs;
  public defaultColDef;
  private rowData;
  public sbuList: any;
  public buList: any;
  public deptList = [];
  public empList = [];
  employeeDropdownSettings: IDropdownSettings = {};
  public monthList = MONTHS;
  public yearList: Number[] = [];
  public tmcId: any;
  public ecrList = [];
  public ecrMonth: number;
  public ecrYear: number;
  selectedSbu: any
  selectedSbuNames: any;
  selectedBuName: any;
  selectedbu: any
  selectedDepartment = [];
  selectedEmployee = [];
  selectedEmployeeCount = 0;
  displayEcrTable = false;
  displayEcrFilled = false;
  displayEcrUnallocated = false;
  frameworkComponents;
  empDOJ: any;


  //#region THR
  thrEmpList: any[] = [];
  thrEmp: any = '';
  thrYear: any = '2023';
  thrMonth: any = '';
  thrList: any[] = [];
  //#endregion

  //#region 
  userId: any = ''
  //#endregion
  public ecrData: { doj: string; lwd: string; }[];
  excelData: any[];
  userIdTHR: any = '';

  uid: any = '';
  currentYear: any = '';

  constructor(private _ecrService: ECRService, private crudService: CrudService, private spinner: NgxSpinnerService) {
    this.ecrSummaryTable();
    this.userId = sessionStorage.getItem("userId");
    this.userId = localStorage.getItem("userId");
    this.userIdTHR = window.sessionStorage.getItem("userIdTHR");
    this.getBuWiseHRList();
    const date = new Date();
    this.currentYear = date.getFullYear();
    this.yearList.push(this.currentYear, this.currentYear - 1);


    this.frameworkComponents = {
      buttonCell: BtnCellRenderer,
    };

    this.employeeDropdownSettings = {
      singleSelection: false,
      idField: 'tmcId',
      textField: 'employee',
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 0,
      allowSearchFilter: true,
      enableCheckAll: false,
      closeDropDownOnSelection: false,
      maxHeight: 280,
      searchPlaceholderText: 'Search employee...',
      noDataAvailablePlaceholderText: 'No employees found'
    };
  }

  ngOnInit() {
    this.createEcrSummaryForm();
    //this.getYearList();
    //this.getSbuList();
    this.getTHREmp();
  }

  getBuWiseHRList() {
    if (sessionStorage.getItem('LoginFlag') == "1") {
      this.uid = sessionStorage.getItem("userId");
    } else {
      this.uid = window.sessionStorage.getItem("userIdTHR");
    }
    this._ecrService.getBuWiseHR(this.uid).subscribe((data: any) => {
      this.buList = data.Data;
    })
  }

  //#region THR
  getTHREmp() {
    this._ecrService.getTHREmp().subscribe((res: any) => {
      if (res.Status) {
        this.thrEmpList = res.Data;
      }
    })
  }

  getDataTHR() {
    let fd = new FormData
    fd.append('Email', this.thrEmp);
    fd.append('Month', this.thrMonth);
    fd.append('Year', this.thrYear);
    this.spinner.show();
    this.crudService.post('Master/GetECRStatusTHR', fd).subscribe((r: any) => {
      //console.log(r);
      if (r.Status) {
        this.spinner.hide();
        this.thrList = r.Data;
      }
      else {
        this.spinner.hide();
      }
    })
  }

  CreateHTMLTable() {
    var tab_text = `<table border="2px" style="font-size:14px">
  <thead>
  <tr style="background-color: yellow;font-weight: bold;">
  <th>ECR Date</th>
  <th>Applied On</th>
  <th>Subject</th>
  <th>Email To</th>
  <th>Email From</th>
  <th>Total ECR Filled</th>
  
  </tr></thead><tbody>`;
    //console.log(this.excelData);
    for (var j = 0; j < this.excelData.length; j++) {

      if (this.excelData[j].ECRDate == undefined || this.excelData[j].ECRDate == 'null' || this.excelData[j].ECRDate == 'undefined') {
        this.excelData[j].ECRDate = ''
      } else {
        this.excelData[j].ECRDate = (this.excelData[j].ECRDate)
      }
      if (this.excelData[j].AppliedOn == undefined || this.excelData[j].AppliedOn == 'null' || this.excelData[j].AppliedOn == 'undefined') {
        this.excelData[j].AppliedOn = ''
      } else {
        this.excelData[j].AppliedOn = (this.excelData[j].AppliedOn)
      }
      if (this.excelData[j].ECRSubject == undefined || this.excelData[j].ECRSubject == 'null' || this.excelData[j].ECRSubject == 'undefined') {
        this.excelData[j].ECRSubject = ''
      }
      if (this.excelData[j].TMCNo == undefined || this.excelData[j].TMCNo == 'null' || this.excelData[j].TMCNo == 'undefined') {
        this.excelData[j].TMCNo = ''
      }

      if (this.excelData[j].ManagerEmail == undefined || this.excelData[j].ManagerEmail == 'null' || this.excelData[j].ManagerEmail == 'undefined') {
        this.excelData[j].ManagerEmail = ''
      }

      if (this.excelData[j].ECR_Filled == undefined || this.excelData[j].ECR_Filled == 'null' || this.excelData[j].ECR_Filled == 'undefined') {
        this.excelData[j].ECR_Filled = ''
      }


      tab_text += `<tr>
    <td>`+ this.excelData[j].ECRDate + `</td>
    <td>`+ this.excelData[j].AppliedOn + `</td>
    <td>`+ this.excelData[j].ECRSubject + `</td>
    <td>`+ this.excelData[j].TMCNo + `</td>
    <td>`+ this.excelData[j].ManagerEmail + `</td>
    <td>`+ this.excelData[j].ECR_Filled + `</td>
    
  </tr>`;
    }
    tab_text += '</tbody> <table>';
    return tab_text;
  }

  GenerateExcel2() {
    this.excelData = this.thrList;
    var table = this.CreateHTMLTable();
    var element = document.createElement('a');
    element.setAttribute('href', 'data:application/vnd.ms-excel,' + encodeURIComponent(table));
    element.setAttribute('download', 'ecrList' + ".xls");
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }
  //#endregion

  //#region AG GRID  
  ecrSummaryTable() {
    this.defaultColDef = {
      resizable: true,
      sortable: true,
      filter: 'agTextColumnFilter',
      suppressMovable: false,
      cellClass: 'hr-grid-cell'
    };

    this.columnDefs = [
      {
        headerName: '#',
        colId: 'index',
        valueGetter: (args) => this._getIndexValue(args) + 1,
        field: 'index',
        width: 56,
        maxWidth: 64,
        sortable: false,
        filter: false,
        cellClass: ['hr-grid-cell', 'hr-grid-cell-center'],
        headerClass: ['hr-grid-header', 'hr-grid-header-center']
      },
      {
        headerName: 'TMC ID',
        colId: 'tmc_id',
        field: 'tmc_id',
        width: 92,
        minWidth: 88,
        cellClass: ['hr-grid-cell', 'hr-grid-cell-center'],
        headerClass: ['hr-grid-header', 'hr-grid-header-center'],
        sortingOrder: ['asc', 'desc']
      },
      {
        headerName: 'Name',
        colId: 'employee_name',
        field: 'employee_name',
        flex: 1,
        minWidth: 110,
        cellClass: 'hr-grid-cell',
        headerClass: 'hr-grid-header',
        tooltipField: 'employee_name',
        sortingOrder: ['asc', 'desc']
      },
      {
        headerName: 'SBU',
        colId: 'SBU',
        field: 'SBU',
        flex: 1.2,
        minWidth: 150,
        cellClass: 'hr-grid-cell',
        headerClass: 'hr-grid-header',
        tooltipField: 'SBU',
        sortingOrder: ['asc', 'desc']
      },
      {
        headerName: 'Department',
        colId: 'Department',
        field: 'Department',
        flex: 1,
        minWidth: 120,
        cellClass: 'hr-grid-cell',
        headerClass: 'hr-grid-header',
        tooltipField: 'Department',
        sortingOrder: ['asc', 'desc']
      },
      {
        headerName: 'Days',
        colId: 'TotalWorkingDays',
        field: 'TotalWorkingDays',
        width: 72,
        minWidth: 68,
        cellClass: ['hr-grid-cell', 'hr-grid-cell-center', 'hr-grid-metric'],
        headerClass: ['hr-grid-header', 'hr-grid-header-center'],
        sortingOrder: ['asc', 'desc']
      },
      {
        headerName: 'Filled',
        colId: 'ECRFilled',
        field: 'ECRFilled',
        width: 80,
        minWidth: 76,
        cellClass: ['hr-grid-cell', 'hr-grid-cell-center', 'hr-grid-metric', 'hr-grid-metric-success'],
        headerClass: ['hr-grid-header', 'hr-grid-header-center'],
        sortingOrder: ['asc', 'desc']
      },
      {
        headerName: 'Pending',
        colId: 'ECRPending',
        field: 'ECRPending',
        width: 88,
        minWidth: 84,
        cellClass: ['hr-grid-cell', 'hr-grid-cell-center', 'hr-grid-metric', 'hr-grid-metric-warning'],
        headerClass: ['hr-grid-header', 'hr-grid-header-center'],
        sortingOrder: ['asc', 'desc']
      },
      {
        headerName: 'Action',
        colId: 'action',
        field: 'action',
        width: 100,
        minWidth: 100,
        maxWidth: 108,
        sortable: false,
        filter: false,
        cellRenderer: 'buttonCell',
        cellRendererParams: {
          clicked: (field: any) => { this.showEcrDetail(field); }
        },
        cellClass: ['hr-grid-cell', 'hr-grid-action-cell'],
        headerClass: ['hr-grid-header', 'hr-grid-header-center']
      }
    ];
  }
  sortByName() {
    this.gridColumnApi.applyColumnState({
      state: [
        {
          colId: 'employee_name',
          sort: 'asc',
        },
      ],
      defaultState: { sort: null },
    });
  }
  private _getIndexValue(args: ValueGetterParams): any {
    return args.node.rowIndex;
  }

  showEcrDetail(field: any) {
    this.ecrYear = Number(this.employeeEcrForm.value.year);
    this.ecrMonth = MONTHS.indexOf(this.employeeEcrForm.value.month) + 1;
    const normalized = {
      ...field,
      tmc_id: field.tmc_id || field.TMCNo || field.TMC || field.tmcId,
      employee_name: field.employee_name || field.EmployeeName || field.Full_Name,
      date_of_joining: field.date_of_joining || field.Date_of_Joining || field.DateOfJoining || field.DOJ,
      date_of_exit: field.date_of_exit || field.Date_of_Exit || field.DateOfExit,
      ecrMonth: this.ecrMonth,
      ecrYear: this.ecrYear
    };
    this.empDOJ = normalized.date_of_joining || null;
    this.employeeDetailTab = 'calendar';
    this.tmcId = normalized;
    document.body.classList.add('hr-ecr-drawer-open');
  }

  get drawerEmployeeTmc(): string {
    if (!this.tmcId) {
      return '';
    }
    return this.tmcId.tmc_id || this.tmcId.TMCNo || this.tmcId.TMC || this.tmcId.tmcId || '';
  }

  get drawerJoinDate(): string {
    const raw = (this.tmcId && this.tmcId.date_of_joining) || this.empDOJ;
    return this.formatDisplayDate(raw);
  }

  get drawerExitDate(): string {
    const raw = this.tmcId && this.tmcId.date_of_exit;
    return this.formatDisplayDate(raw);
  }

  formatDisplayDate(value: any): string {
    if (!value || value === 'ALL') {
      return '';
    }
    const parsed = this.parseDisplayDate(value);
    if (!parsed) {
      return String(value);
    }
    const dd = ('0' + parsed.getDate()).slice(-2);
    const mm = ('0' + (parsed.getMonth() + 1)).slice(-2);
    return dd + '/' + mm + '/' + parsed.getFullYear();
  }

  private parseDisplayDate(value: any): Date | null {
    if (value instanceof Date && !isNaN(value.getTime())) {
      return value;
    }
    const text = String(value).trim();
    const dmY = text.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    if (dmY) {
      return new Date(Number(dmY[3]), Number(dmY[2]) - 1, Number(dmY[1]));
    }
    const parsed = new Date(text);
    return isNaN(parsed.getTime()) ? null : parsed;
  }

  closeEcrDetail(): void {
    this.tmcId = null;
    this.empDOJ = null;
    this.employeeDetailTab = 'calendar';
    document.body.classList.remove('hr-ecr-drawer-open');
  }

  get showThrWorkspace(): boolean {
    return this.userId === '6000' || this.userId === '10124'
      || this.userIdTHR === 'THR030' || this.userIdTHR === 'THR101212';
  }

  get ecrSummaryStats(): { employees: number; filled: number; pending: number; avgCompliance: number } {
    if (!this.ecrList || !this.ecrList.length) {
      return { employees: 0, filled: 0, pending: 0, avgCompliance: 0 };
    }
    const filled = this.ecrList.reduce((sum, row) => sum + (Number(row.ECRFilled) || 0), 0);
    const pending = this.ecrList.reduce((sum, row) => sum + (Number(row.ECRPending) || 0), 0);
    const working = this.ecrList.reduce((sum, row) => sum + (Number(row.TotalWorkingDays) || 0), 0);
    const avgCompliance = working > 0 ? Math.round((filled / working) * 100) : 0;
    return { employees: this.ecrList.length, filled, pending, avgCompliance };
  }

  @HostListener('document:keydown.escape')
  onEscapeKey(): void {
    if (this.tmcId) {
      this.closeEcrDetail();
    }
  }

  ngOnDestroy(): void {
    document.body.classList.remove('hr-ecr-drawer-open');
  }

  sizeToFit() {
    this.gridApi.sizeColumnsToFit();
  }
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    if (this.ecrList && this.ecrList.length) {
      params.api.setRowData(this.ecrList);
    }
    this.refreshGridLayout();
  }

  @HostListener('window:resize')
  onWindowResize() {
    this.refreshGridLayout();
  }

  private refreshGridLayout() {
    if (!this.gridApi || window.innerWidth < 1024) {
      return;
    }
    this.gridApi.sizeColumnsToFit();
  }

  onColumnMoved() {
    if (this.gridApi) {
      this.gridApi.refreshHeader();
    }
  }



  //#region download file
  onBtnExport() {
    const exportBU = (this.employeeEcrForm.value['bu'] && this.employeeEcrForm.value['bu'].buName)
      ? this.employeeEcrForm.value['bu'].buName
      : '';
    const exportDepartment = (this.employeeEcrForm.value['department'] && this.employeeEcrForm.value['department'].departmentmaster && this.employeeEcrForm.value['department'].departmentmaster.departmentName)
      ? this.employeeEcrForm.value['department'].departmentmaster.departmentName
      : '';
    const prependData = [
      [
        { data: { value: 'BU:', type: 'String', mergeAcross: 8 } },
        { data: { value: exportBU, type: 'String', mergeAcross: 8 } }
      ],
      [
        { data: { value: 'Department:', type: 'String', mergeAcross: 8 } },
        { data: { value: exportDepartment, type: 'String', mergeAcross: 8 } }
      ],
      [{
        data: {
          value: `Employee:`,
          type: 'String',
          mergeAcross: 8
        },
      },
      {
        data: {
          value: (this.employeeEcrForm.value['employee'] || [])
            .map((e: any) => e.employee || e.tmcId || e).join(', '),
          type: 'String',
          mergeAcross: 8
        },
      }],
      [{
        data: {
          value: `Month:`,
          type: 'String',
          mergeAcross: 8
        },
      },
      {
        data: {
          value: `${this.employeeEcrForm.value['month']}`,
          type: 'String',
          mergeAcross: 8
        },
      }],
      [{
        data: {
          value: `Year:`,
          type: 'String',
          mergeAcross: 8
        },
      },
      {
        data: {
          value: `${this.employeeEcrForm.value['year']}`,
          type: 'String',
          mergeAcross: 8
        },
      }],
      // Object.keys(this.employeeEcrForm.value).map(k => {
      //   return {
      //     data: {
      //       value: `${k.toUpperCase()}: ${this.employeeEcrForm.value[k]}`,
      //       type: 'String',
      //     },
      //   }
      // }),
      [
        {
          data: {
            value: `Created On:`,
            type: 'String',
          },
        },
        {
          data: {
            value: `${new Date().toLocaleDateString()}`,
            type: 'String',
          },
        },
      ],
      [
        {
          data: {
            value: `Created By:`,
            type: 'String',
          },
        },
        {
          data: {
            value: `${sessionStorage.getItem("FullName")}`,
            type: 'String',
          },
        },
      ],
      [],
    ];
    var params = {
      fileName: this._empEcrStatus(),
      prependContent: prependData
    };

    this.gridApi.exportDataAsCsv(params);
  }

  private _empEcrStatus() {
    const date = new Date;
    return `EcrStatus${date.getMilliseconds()}.csv`

  }

  //#endregion

  //#region ECR Form
  createEcrSummaryForm() {
    this.employeeEcrForm = new FormGroup({
      bu: new FormControl('', Validators.required),
      sbu: new FormControl('', Validators.required),
      department: new FormControl('', Validators.required),
      employee: new FormControl([], EcrForHrComponent.employeeRequired),
      month: new FormControl('January', Validators.required),
      year: new FormControl(this.currentYear, Validators.required),
    });
  }

  private static employeeRequired(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    return Array.isArray(value) && value.length > 0 ? null : { required: true };
  }


  submitForm() {
    if (!this.employeeEcrForm.valid) return;

    const formValue = { ...this.employeeEcrForm.value };
    const payload = {
      ...formValue,
      employee: (formValue.employee || []).map((emp: any) => emp.tmcId || emp)
    };
    this.spinner.show();

    this._ecrService.postEcr(payload).subscribe({
      next: (res: any) => {
        this.ecrList = res && res.Data ? res.Data : [];
        this.displayEcrTable = true;
      },
      error: () => {
        this.ecrList = [];
      },
      complete: () => {
        this.spinner.hide();
        setTimeout(() => this.refreshGridLayout(), 0);
      }
    });
  }

  //#endregion

  //#region Get APIs
  getYearList() {
    const date = new Date;
    this.yearList.push(date.getFullYear(), date.getFullYear() - 1);
  }

  getSbuList(selectedBuId: any) {
    console.log('fetch selectedBuId:', selectedBuId);
    this._ecrService.getSbuList(selectedBuId).subscribe((res: any) => {
      console.log('SBU Response:', res);

      this.sbuList = res.Data.map((x: any) => ({
        sbuId: x.sbumaster.sbuId,
        sbuName: x.sbumaster.sbuName,
        code: x.sbumaster.code
      }));

      console.log('Mapped SBU List:', this.sbuList);
    });
  }


  getDeptList(selectedSbu: any[]) {
    console.log('Selected SBU for Dept Fetch:', selectedSbu);
    this._ecrService.getDepartmentBUwise(selectedSbu).subscribe({
      next: (res: any) => {
        if (res && res.Status && Array.isArray(res.Data)) {
          this.deptList = [
            { departmentmaster: { departmentName: 'ALL' }, departmentMappingId: 'ALL' }, // ✅ All option
            ...res.Data
          ];
        } else {
          this.deptList = [
            { departmentmaster: { departmentName: 'ALL' }, departmentMappingId: 'ALL' }
          ];
        }
      },
      error: () => {
        this.deptList = [];
      }
    });
  }


  // getEmpList(sbu, department) {
  //   this._ecrService.getEmpList(sbu, department).subscribe(data => {
  //     let newData = data['employee_data'];
  //     console.log(newData);
  //     this.empList = newData.map(employee => {
  //       return {
  //         employee: `${employee.employee_name} - ${employee.tmc_id}`,
  //         tmcId: employee.tmc_id
  //       }
  //     });
  //     this.empList.sort((a, b) => a.localeCompare(b));
  //   });
  // }

  getEmpList(buName, department) {
    this._ecrService.getEmpList(buName, department).subscribe((data: any) => {
      let newData = data && data.Data ? data.Data : [];
      if (!Array.isArray(newData)) {
        newData = [];
      }

      this.empList = newData.map(employee => {
        return {
          employee: `${employee.Full_Name} - ${employee.TMC}`,
          tmcId: employee.TMC,
          sbu: employee.SBU,
          department: employee.Department,
          Location_Code: employee.Location_Code,
          DateOfJoining: employee.Date_of_Joining
        };
      });

      this.empList.unshift({
        employee: 'ALL',
        tmcId: 'ALL',
        sbu: 'ALL',
        department: 'ALL',
        Location_Code: 'ALL',
        DateOfJoining: 'ALL'
      });

      this.empList = [
        this.empList[0],
        ...this.empList.slice(1).sort((a, b) => a.employee.localeCompare(b.employee))
      ];
      this.employeeChangeHandler();
    }, () => {
      this.empList = [{
        employee: 'ALL',
        tmcId: 'ALL',
        sbu: 'ALL',
        department: 'ALL',
        Location_Code: 'ALL',
        DateOfJoining: 'ALL'
      }];
      this.employeeChangeHandler();
    });
  }
  // postEcr() {
  //   this._ecrService.postEcr(this.employeeEcrForm.value).subscribe(data => {
  //     this.ecrList = data;
  //   })
  // }
  //#endregion

  //#region change handler
  buChangeHandler() {
    const buControl = this.employeeEcrForm.get('bu');
    const selectedBu = buControl ? buControl.value : null;

    this.deptList = [];
    this.clearEmployeeSelection();

    this.employeeEcrForm.patchValue({
      sbu: '',
      department: '',
      employee: [],
      tmcId: ''
    });

    if (selectedBu) {
      this.selectedBuName = selectedBu.buName;
      this.getSbuList(selectedBu.buId);
    } else {
      this.selectedBuName = '';
      this.sbuList = [];
    }
  }

  sbuChangeHandler() {
    const sbuControl = this.employeeEcrForm.get('sbu');
    const selectedSbu = sbuControl ? sbuControl.value : null;

    this.deptList = [];
    this.clearEmployeeSelection();

    this.employeeEcrForm.patchValue({
      department: '',
      employee: [],
      tmcId: ''
    });

    if (selectedSbu) {
      this.getDeptList(selectedSbu.sbuId);
    }
  }

  deptChangeHandler() {
    const control = this.employeeEcrForm.get('department');

    if (!control) {
      return;
    }

    const selected = control.value;
    this.clearEmployeeSelection();

    if (!selected || !selected.departmentmaster) {
      return;
    }

    const dept = selected.departmentmaster;
    const buName = this.selectedBuName || '';

    if (!buName) {
      return;
    }

    this.getEmpList(buName, dept.departmentName);
  }

  private clearEmployeeSelection(): void {
    this.empList = [];
    this.selectedEmployee = [];
    this.selectedEmployeeCount = 0;

    const employeeControl = this.employeeEcrForm.get('employee');
    if (employeeControl) {
      employeeControl.setValue([], { emitEvent: false });
    }
    this.employeeEcrForm.patchValue({ tmcId: '' }, { emitEvent: false });
  }







  //   deptChangeHandler(event: any) {
  //   const selected = event.target.value;
  //   console.log("Selected Department:", selected);
  //   console.log("Department Name:", selected.departmentmaster.departmentName);
  //   console.log("Department ID:", selected.departmentmaster.id);

  //   const sbuName = this.selectedSbuNames; // keeping your previous logic
  //   // this.getEmpList(sbuName, selectedDeptId);
  // }



  get employeeSelectionSummary(): string {
    const control = this.employeeEcrForm ? this.employeeEcrForm.get('employee') : null;
    const selected = control && control.value ? control.value : [];
    if (!selected.length) {
      return '';
    }
    if (selected.length === 1) {
      return this.getShortEmployeeName(selected[0]);
    }
    return `${selected.length} employees selected`;
  }

  get employeeSelectionTitle(): string {
    const control = this.employeeEcrForm ? this.employeeEcrForm.get('employee') : null;
    const selected = control && control.value ? control.value : [];
    return selected.map((e: any) => e.employee).join(', ');
  }

  getShortEmployeeName(item: any): string {
    const label = item && item.employee ? item.employee : '';
    const dash = label.lastIndexOf(' - ');
    return dash > -1 ? label.substring(0, dash).trim() : label;
  }

  employeeChangeHandler(): void {
    const control = this.employeeEcrForm.get('employee');
    const selected = control ? control.value || [] : [];
    this.selectedEmployee = selected;
    this.selectedEmployeeCount = selected.length;
  }
  //#endregion

  //#region mock function
  showFilledEcr() {
    this.displayEcrFilled = true;
    this.displayEcrUnallocated = false;
  }
  showUnallocatedEcr() {
    this.displayEcrUnallocated = true;
    this.displayEcrFilled = false;
  }
  //#endregion
  setEmployeeDOJ(doj) {
    this.empDOJ = doj;
    if (this.tmcId) {
      this.tmcId.date_of_joining = doj;
    }
  }
}

//#region cell renderer
@Component({
  selector: 'btn-cell-renderer',
  template: `
    <div class="hr-grid-action-wrap">
      <button type="button" class="hr-grid-view-btn" (click)="btnClickedHandler($event)">
        <i class="las la-eye"></i>
        <span>View</span>
      </button>
    </div>
  `,
  styles: [`
    :host {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
    }
    .hr-grid-action-wrap {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
    }
    .hr-grid-view-btn {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 4px;
      height: 30px;
      padding: 0 10px;
      border: 1px solid rgba(15, 139, 141, 0.28);
      border-radius: 8px;
      background: rgba(15, 139, 141, 0.1);
      color: #0c7072;
      font-size: 11px;
      font-weight: 700;
      line-height: 1;
      cursor: pointer;
      white-space: nowrap;
    }
    .hr-grid-view-btn i {
      font-size: 14px;
    }
    .hr-grid-view-btn:hover {
      background: rgba(15, 139, 141, 0.18);
    }
  `]
})
export class BtnCellRenderer implements ICellRendererAngularComp, OnDestroy {
  public params: any;
  value;

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    return true;
  }

  agInit(params: any): void {
    this.params = params;
    if (params.colDef.field == "ACTION") {
      this.value = "Edit";
    }
    else if (params.colDef.field == "VIEW") {
      this.value = "VIEW";
    } else if (params.colDef.field == "DELETE") {
      this.value = "DELETE";
    }
  }

  btnClickedHandler(event) {
    this.params.clicked(this.params.data);
  }

  btnDisableClickHandler(event) {
    this.params.disableClicked(this.params.data);
  }

  btnEnableClickHandler(event) {
    this.params.enableClicked(this.params.data);
  }

  ngOnDestroy() {
    // no need to remove the button click handler
    // https://stackoverflow.com/questions/49083993/does-angular-automatically-remove-template-event-listeners
  }
}


